const getMinMaxRounded = ({
    minAmount,
    maxAmount,
    MIN_DECIMAL_POINTS_THRESHOLD = 10000,
    MAX_DECIMAL_POINTS_THRESHOLD = 10000,
}: {
    minAmount: number
    maxAmount: number
    MIN_DECIMAL_POINTS_THRESHOLD?: number
    MAX_DECIMAL_POINTS_THRESHOLD?: number
}): { minAmount: number; maxAmount: number } => {
    return {
        minAmount:
            Math.ceil(minAmount * MIN_DECIMAL_POINTS_THRESHOLD) / MIN_DECIMAL_POINTS_THRESHOLD,
        maxAmount:
            Math.floor(maxAmount * MAX_DECIMAL_POINTS_THRESHOLD) / MAX_DECIMAL_POINTS_THRESHOLD,
    }
}

const getAmountRounded = (amount: number | string, decimalPoint: number = 9): number => {
    if (!amount && amount !== 0) {
        return Number(amount)
    }
    return Number(Number(amount).toFixed(decimalPoint))
}

export { getMinMaxRounded, getAmountRounded }
